// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool will that builds a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file isn't exported, because we don't want the _TL_ syntax visible in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  Account_CPFLabel: _TL_(
    'CPF',
    {
      comment: 'Label for Tax Id for Brazilian Individual customers (Cadastro de Pessoas Físicas)',
    }
  ),
  Account_CNPJLabel: _TL_(
    'CNPJ',
    {
      comment: 'Label for Tax Id for Brazilian Business customers (Cadastro Nacional da Pessoa Jurídica)',
    }
  ),
  Account_GSTINLabel: _TL_(
    'GST IN',
    {
      comment: 'Label of GST(Goods and Services Tax) for Indian indirect taxation system',
    }
  ),
  Account_PANLabel: _TL_(
    'PAN',
    {
      comment: 'Label for Tax Id for Indian Personal/Business customers (Permanent Account Number)',
    }
  ),
  Account_VATShortLabel: _TL_(
    'VAT',
    {
      comment: 'Label for VAT tax Id for taxable EMEA countries',
    }
  ),
  Account_VATIdLabel: _TL_(
    'VAT ID',
    { comment: 'Label for VAT tax id for global countries' }
  ),
  Account_NITLabel: _TL_(
    'NIT',
    {
      comment: 'Label for NIT tax Id',
    }
  ),
  Account_BINLabel: _TL_(
    'BIN',
    {
      comment: 'Label for BIN tax Id',
    }
  ),
  Account_NPWPLabel: _TL_(
    'NPWP',
    {
      comment: 'Label for NPWP tax Id',
    }
  ),
  Account_TINLabel: _TL_(
    'TIN',
    {
      comment: 'Label for TIN tax Id',
    }
  ),
  Account_TaxIDLabel: _TL_(
    'Tax ID',
    {
      comment: 'Label for tax Id',
    }
  ),
  Account_TINOrVATLabel: _TL_(
    'TIN or VAT ID',
    {
      comment: 'Label for TIN or VAT tax Id',
    }
  ),
  Account_TRNOrVATLabel: _TL_(
    'TRN or VAT ID',
    {
      comment: 'Label for TRN or VAT tax Id',
    }
  ),
  Account_VKNLabel: _TL_(
    'VKN',
    {
      comment: 'Label for VKN tax Id',
    }
  ),
  Account_VAT_TINLabel: _TL_(
    'VAT-TIN',
    {
      comment: 'Label for VAT-TIN tax Id',
    }
  ),
  Account_RFCLabel: _TL_(
    'RFC',
    {
      comment: 'Label for RFC tax Id',
    }
  ),
  Account_NDSKKSLabel: _TL_(
    'NDS/KKS',
    {
      comment: 'Label for NDS/KKS tax Id',
    }
  ),
  Account_AAHLabel: _TL_(
    'AAH',
    {
      comment: 'Label for AAH tax Id',
    }
  ),
  Account_CUITLabel: _TL_(
    'CUIT',
    {
      comment: 'Label for CUIT tax Id',
    }
  ),
  Account_VOENLabel: _TL_(
    'VÖEN',
    {
      comment: 'Label for VÖEN tax Id',
    }
  ),
  Account_IFULabel: _TL_(
    'IFU',
    {
      comment: 'Label for IFU tax Id',
    }
  ),
  Account_nTVALabel: _TL_(
    'n° TVA',
    {
      comment: 'Label for n° TVA tax Id',
    }
  ),
  Account_JCTLabel: _TL_(
    'JCT',
    {
      comment: 'Label for JCT tax Id',
    }
  ),
  Account_SSTLabel: _TL_(
    'SST',
    {
      comment: 'Label for SST tax Id',
    }
  ),
  Account_TBCLabel: _TL_(
    'TBC',
    {
      comment: 'Label for TBC tax Id',
    }
  ),
  Account_FINLabel: _TL_(
    'FIN',
    {
      comment: 'Label for FIN tax Id',
    }
  ),
  Account_VATRegNoLabel: _TL_(
    'VAT Reg. No.',
    {
      comment: 'Label for VAT Reg. No. tax Id',
    }
  ),
  Account_RIFLabel: _TL_(
    'RIF',
    {
      comment: 'Label for RIF tax Id',
    }
  ),
  Account_TPINLabel: _TL_(
    'TPIN',
    {
      comment: 'Label for TPIN tax Id',
    }
  ),
  Account_BRNLabel: _TL_(
    'BRN',
    {
      comment: 'Label for BRN tax Id',
    }
  ),
  Account_RUCLabel: _TL_(
    'RUC',
    {
      comment: 'Label for RUC tax Id',
    }
  ),
  Account_RUTLabel: _TL_(
    'RUT',
    {
      comment: 'Label for RUT tax Id',
    }
  ),
  Account_STRNLabel: _TL_(
    'STRN',
    {
      comment: 'Label for STRN tax Id',
    }
  ),
  Account_VAT_AbsentMessage: _TL_(
    'Failure to provide your VAT registration number may result in tax being applied to your invoice.',
    {
      comment: 'Message to call out the consequence of not providing the tax ID',
    }
  ),
  Account_VAT_AbsentMessage_Serbia: _TL_(
    'Failure to provide your Tax Identification Number may result in tax being applied to your invoice.',
    {
      comment: 'Message to call out the consequence of not providing the tax ID for Serbia',
    }
  ),
  Account_ABNLabel: _TL_(
    'Australian Business Number',
    {
      comment: 'Label for Australian Business Number',
    }
  ),
  Account_NZGSTRegistrationNumberLabel: _TL_(
    'NZ GST registration number',
    {
      comment: 'Label for entering the New Zealand GST regisration number of an account.',
    }
  ),
  Account_GSTRegistrationNumberLabel: _TL_(
    'GST/HST registration number or Business Number',
    {
      comment: 'Label for entering the GST regisration number of an account.',
    }
  ),
  Account_PSTRegistrationNumberLabel: _TL_(
    'PST registration number',
    {
      comment: 'Label for entering the PST regisration number of an account.',
    }
  ),
  Account_QSTRegistrationNumberLabel: _TL_(
    'QST registration number',
    {
      comment: 'Label for entering the QST regisration number of an account.',
    }
  ),
  Account_CCMLabel: _TL_(
    'C.C.M.',
    {
      comment: 'Label for Tax Id for Brazilian Business customers (Cadastro de Contribuinte Mobiliário)',
    }
  ),
  Account_IELabel: _TL_(
    'IE',
    {
      comment: 'Label for Tax Id for Brazilian Personal/Business customers',
    }
  ),
  Account_UINLabel: _TL_(
    'UIN',
    {
      comment: 'Label for Unique Identification Number',
    }
  ),
  Account_TRNLabel: _TL_(
    'TRN',
    {
      comment: 'Label for Tax Registration Number',
    }
  ),
  TaxType_1: _TL_('Personal'),
  TaxType_2: _TL_('Business'),
  Account_TaxTypeLabel: _TL_('Tax type'),
  Label_Optional: _TL_('(optional)'),
  Label_State_Tax_ID_Optional: _TL_('(State Tax ID, optional)'),
  Label_Required: _TL_('(required)'),
  Label_RequiredForBusinessCustomers: _TL_('(required for business customers)'),
  Label_RequiredForTaxRegisteredCustomers: _TL_('(required for tax registered customers)'),
  Label_RequiredForVATRegisteredBusinessCustomers: _TL_('(required for VAT registered business customers)'),
  Label_RequiredForCustomersClaimingTaxExemption: _TL_('(required for customers claiming a tax exemption)'),
  Label_RequiredForValueAddedTaxIVARegisteredCustomers: _TL_('(required for Value Added Tax/IVA registered customers)'),
  Label_RequiredForAllTheEntities: _TL_('(required for all the entities)'),
  Account_ReverseChargeDocumentLabel: _TL_('Reverse Charge Document'),
  Account_ReverseChargeDocument_Download: _TL_('(Please download {{link}}this document{{/link}}, fill in the required fields, and upload it below.)'),
  Account_Attestation_Label: _TL_('Please attest that the above Reverse Charge Document has been uploaded by an employee of the company that is receiving advertising services from Microsoft Advertising, and that the uploader understands the reverse charge account concept and the company\'s VAT return filing obligations.'),
  Account_ReverseChargeDocumentAttestation_Positive: _TL_('Yes'),
  Account_ReverseChargeDocumentAttestation_Negative: _TL_('No'),
  Account_ReverseChargeDocumentAttestation_Positive_StaticViewStatement: _TL_('You have attested that the above Reverse Charge Document has been uploaded by an employee of the company that is receiving advertising services from Microsoft Advertising, and that the uploader understands the reverse charge account concept and the company\'s VAT return filing obligations.'),
  Account_ReverseChargeDocumentAttestation_Negative_StaticViewStatement: _TL_('You haven’t attested that the above Reverse Charge Document has been uploaded by an employee of the company that is receiving advertising services from Microsoft Advertising, and that the uploader understands the reverse charge account concept and the company\'s VAT return filing obligations.'),
  Account_ReverseChargeDocument_Uploaded: _TL_('Your reverse charge document has been uploaded.'),
  Account_TaxCertificate_Uploaded: _TL_('Your tax certificate has been uploaded.'),
  Account_PANMissingMessage: _TL_(
    'Enter your 10-digit alphanumeric Permanent Account Number.',
    {
      comment: 'Error message displayed for India accounts when user didn\'t provide any PAN',
    }
  ),
  Account_PANFormatValidationMessage: _TL_(
    'This PAN is not valid. Please re-enter your 10-digit alphanumeric code.',
    {
      comment: 'Validation message that is shown for a PAN account if a tax ID is entered in the wrong format.',
    }
  ),
  Account_VATValidationMessage: _TL_(
    'Enter a valid VAT registration number without spaces.',
    {
      comment: 'Error message shown for an EMEA account when the provided VAT tax id is an invalid format. VAT stands for Value-Added Tax.',
    }
  ),
  Account_UnitedArabEmiratesVATFormatValidationMessage: _TL_(
    'This TRN or VAT ID must be in the following 15-digit format, where # represents a number: ###############.',
    {
      comment: 'Error message shown for United Arab Emirates account when the provided tax id is an invalid format.',
    }
  ),
  Account_IsraelVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 9-digit format, where # represents a number: ##########.',
    {
      comment: 'Error message shown for Israel account when the provided tax id is an invalid format.',
    }
  ),
  Account_VietnamVATFormatValidationMessage: _TL_(
    'This TIN must be in one of the following formats, where # represents a number: ########## or ##########-###.',
    {
      comment: 'Error message shown for Vietnam account when the provided tax id is an invalid format.',
    }
  ),
  Account_NorwayVATFormatValidationMessage: _TL_(
    'This VAT ID is invalid. Please re-enter.',
    {
      comment: 'Error message shown for Norway account when the provided tax id is an invalid format.',
    }
  ),
  Account_TurkeyVATFormatValidationMessage: _TL_(
    'This VKN must be in one of the following formats, where # represents a number: ########## or ###########.',
    {
      comment: 'Error message shown for Turkey account when the provided tax id is an invalid format.',
    }
  ),
  Account_GlobalThailandVATFormatValidationMessage: _TL_(
    'This VAT ID must be in one of the following formats, where # represents a number: #-####-#####-##-# or #############.',
    {
      comment: 'Error message shown for Thailand account when the provided tax id is an invalid format.',
    }
  ),
  Account_GeorgiaVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 9-digit format, where # represents a number: #########.',
    {
      comment: 'Error message shown for Georgia account when the provided tax id is an invalid format.',
    }
  ),
  Account_BangladeshVATFormatValidationMessage: _TL_(
    'This BIN must be in the following 13-digit format, where # represents a number: #########-####.',
    {
      comment: 'Error message shown for Bangladesh account when the provided tax id is an invalid format.',
    }
  ),
  Account_IndonesiaVATFormatValidationMessage: _TL_(
    'This NPWP must be in one of the following formats, where # represents a number: ##.###.###.#-###.### or ###############.',
    {
      comment: 'Error message shown for Indonesia account when the provided tax id is an invalid format.',
    }
  ),
  Account_BelarusVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 9-digit format, where # represents a number: #########.',
    {
      comment: 'Error message shown for Belarus account when the provided tax id is an invalid format.',
    }
  ),
  Account_IcelandVATFormatValidationMessage: _TL_(
    'This VAT ID must be in one of the following formats, where # represents a number: ##### or ######.',
    {
      comment: 'Error message shown for Iceland account when the provided tax id is an invalid format.',
    }
  ),
  Account_MoldovaVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 7-digit format, where # represents a number: #######.',
    {
      comment: 'Error message shown for Moldova account when the provided tax id is an invalid format.',
    }
  ),
  Account_ZimbabweVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 8-digit format, where # represents a number: ########.',
    {
      comment: 'Error message shown for Zimbabwe account when the provided tax id is an invalid format.',
    }
  ),
  Account_GlobalNigeriaVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following format, where # represents a number: ########-####.',
    {
      comment: 'Error message shown for Nigeria account when the provided tax id is an invalid format.',
    }
  ),
  Account_BahrainVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following format, where # represents a number: 2##############.',
    {
      comment: 'Error message shown for Bahrain account when the provided tax id is an invalid format.',
    }
  ),
  Account_CambodiaVATFormatValidationMessage: _TL_(
    'This TIN must be in one of the following formats, where # represents a number: B0##-#########, E0##-##########, K0##-#########, or L001-#########.',
    {
      comment: 'Error message shown for Cambodia account when the provided tax id is an invalid format.',
    }
  ),
  Account_KenyaVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following format, where # represents a number and * represents a letter: P#########*.',
    {
      comment: 'Error message shown for Kenya account when the provided tax id is an invalid format.',
    }
  ),
  Account_SaudiArabiaVATFormatValidationMessage: _TL_(
    'This TIN or VAT ID must be in the following 15-digit format, where # represents a number: ###############.',
    {
      comment: 'Error message shown for Saudi Arabia account when the provided tax id is an invalid format.',
    }
  ),
  Account_OmanVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following format, where # represents a number: OM##########.',
    {
      comment: 'Error message shown for Oman account when the provided tax id is an invalid format.',
    }
  ),
  Account_GhanaVATFormatValidationMessage: _TL_(
    'This TIN must be in one of the following formats, where # represents a number: C########## or P##########.',
    {
      comment: 'Error message shown for Ghana account when the provided tax id is an invalid format.',
    }
  ),
  Account_CameroonVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following format, where # represents a number and * represents a letter: *############*.',
    {
      comment: 'Error message shown for Cameroon account when the provided tax id is an invalid format.',
    }
  ),
  Account_UzbekistanVATFormatValidationMessage: _TL_(
    'This VAT ID must be in the following 12-digit format, where # represents a number: ############.',
    {
      comment: 'Error message shown for Uzbekistan account when the provided tax id is an invalid format.',
    }
  ),
  Account_FijiVATFormatValidationMessage: _TL_(
    'This TIN must be in one of the following formats, where # represents a number: ##-#####-#-# or ##########.',
    {
      comment: 'Error message shown for Fiji account when the provided tax id is an invalid format.',
    }
  ),
  Account_GuatemalaVATFormatValidationMessage: _TL_(
    'This NIT must be in the following format, where # represents a number: #######-#.',
    {
      comment: 'Error message shown for Guatemala account when the provided tax id is an invalid format.',
    }
  ),
  Account_TheBahamasVATFormatValidationMessage: _TL_(
    'The TIN must be in the following 9-digit format, where # represents a number: #########.',
    {
      comment: 'Error message shown for The Bahamas account when the provided tax id is an invalid format.',
    }
  ),
  Account_PhilippinesVATFormatValidationMessage: _TL_(
    'This TIN must be in one of the following formats, where # represents a number: ###-###-###, ###-###-###-### or ###-###-###-#####.',
    {
      comment: 'Error message shown for Philippines account when the provided tax id is an invalid format.',
    }
  ),
  FilePicker_ErrorMessage_Required_Global: _TL_(
    'Please upload your tax certificate document associated with your {{taxId}}.',
    {
      comment: 'Error message shown for an account when the tax certificate is not provided',
    }
  ),
  Account_GSTINFormatValidationMessage: _TL_(
    'This Goods and Services Tax identification number is not valid. Please check and re-enter your GST IN.',
    {
      comment: 'Validation message that is shown for a GSTIN account if a tax ID is entered in the wrong format.',
    }
  ),
  Account_CPFValidationMessage: _TL_(
    'This CPF is not valid. Please re-enter your 11-digit number.',
    {
      comment: 'Error message shown for a personal BRL account when the provided tax id is invalid',
    }
  ),
  Account_CNPJValidationMessage: _TL_(
    'This CNPJ is not valid. Please re-enter your 14-digit number.',
    {
      comment: 'Error message shown for a business BRL account when the provided tax id is invalid',
    }
  ),
  Account_CNPJMissingMessage: _TL_(
    'CNPJ is required for business accounts.',
    {
      comment: 'Error message displayed for Brazilian business accounts when user didn\'t provide any CNPJ number',
    }
  ),
  Account_CCMMissingMessage: _TL_(
    'C.C.M is required for business accounts with business address in Sao Paulo city',
    {
      comment: 'Error message displayed for Brazilian business accounts in Sao Paulo when user didn\'t provide any CCM number',
    }
  ),
  Account_CCMValidationMessage: _TL_(
    'This C.C.M. is not valid. Reenter your 8-digit number.',
    {
      comment: 'Error message shown for a business BRL account when the provided tax id is invalid',
    }
  ),
  Account_IEValidationMessage: _TL_(
    'This IE is invalid. Please enter a valid 9 to 14-digit number or letter.',
    {
      comment: 'Error message shown for a personal/business BRL account when the provided tax id is invalid',
    }
  ),
  Account_ABNValidationMessage: _TL_('This ABN is not valid. Reenter your 11-digit number without spaces.'),
  Account_NZGSTRegistrationNumberFormatValidationMessage: _TL_(
    'This GST registration number is not valid. Please reenter your 8- or 9-digit registration using numbers only.',
    {
      comment: 'Validation message that is shown for a NZ GST account if a tax ID is entered in the wrong format.',
    }
  ),
  Account_NewZealandGSTRegistrationNumberFormatValidationMessage: _TL_(
    'Enter a valid GST without spaces.',
    {
      comment: 'Validation message that is shown for a NZ GST account if a tax ID is entered in the wrong format. (For TaxForm component)',
    }
  ),
  Account_SGGSTRegistrationNumberFormatValidationMessage: _TL_(
    'This GST is not valid. Please re-enter it.',
    {
      comment: 'Validation message that is shown for a SG GST account if a tax ID is entered in the wrong format.',
    }
  ),
  Account_PIBLabel: _TL_(
    'Tax identification number (PIB)',
    {
      comment: 'Label for Tax Id for Serbia customers (Poreski Identifikacioni Broj)',
    }
  ),
  Account_PIBNumberMissingMessage: _TL_(
    'Please enter your tax identification number (PIB).',
    {
      comment: 'Error message displayed for required Tax identification number',
    }
  ),
  Account_PIBNumberFormatValidationMessage: _TL_(
    'Please re-enter your tax identification number (PIB).',
    {
      comment: 'Validation message that is shown for a Serbia account if a tax ID is entered in the wrong format.',
    }
  ),
  Account_LegalNumberLabel: _TL_('Legal number'),
  Account_SerbiaLegalNumberFormatValidationMessage: _TL_('The Legal number must be in the following format: XXXXXXXX, where X represents a digit.'),
  Account_IndiaGSTINFormatValidationMessage: _TL_(
    'This GSTIN is not valid. Please re-enter your 15-digit alphanumeric code.',
    {
      comment: 'Validation message that is shown for a India account if a tax ID GSTIN is entered in the wrong format.',
    }
  ),
  Account_LegalIdentifierNumber: _TL_(
    'Legal Identifier Number',
    { comment: 'Label for Australian Business Number' }
  ),
  Armenia_Legal_Identifier_Description: _TL_('Please provide your UNN/Public service number.'),
  Azerbaijan_Legal_Identifier_Description: _TL_('Please provide your TIN/INN/PIC.'),
  Brazil_Legal_Identifier_Description: _TL_('Please provide your CPF.'),
  China_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Hungary_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Turkey_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  India_Legal_Identifier_Description: _TL_('Please provide your TIN/PAN.'),
  Iraq_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Kazakhstan_Legal_Identifier_Description: _TL_('Please provide your BIN/IIN.'),
  Kyrgyzstan_Legal_Identifier_Description: _TL_('Please provide your INN.'),
  Moldova_Legal_Identifier_Description: _TL_('Please provide your IDNO/IDNP/Fiscal Code.'),
  Myanmar_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Poland_Legal_Identifier_Description: _TL_('Please provide your TIN/PESEL.'),
  Russia_Legal_Identifier_Description: _TL_('Please provide your INN.'),
  Saudi_Arabia_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  South_Africa_Legal_Identifier_Description: _TL_('Please provide your TRN.'),
  South_Sudan_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Tajikistan_Legal_Identifier_Description: _TL_('Please provide your INN/EIN/KPP.'),
  Thailand_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Ukraine_Legal_Identifier_Description: _TL_('Please provide your EGRPOU/EDRPOU.'),
  United_Arab_Emirates_Legal_Identifier_Description: _TL_('Please provide your 5 Digits Commercial License number or 15 Digits VAT TRN.'),
  Uzbekistan_Legal_Identifier_Description: _TL_('Please provide your INN.'),
  Venezuela_Legal_Identifier_Description: _TL_('Please provide your RIF.'),
  Vietnam_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Bangladesh_Legal_Identifier_Description: _TL_('Please provide your PAN.'),
  Bhutan_Legal_Identifier_Description: _TL_('Please provide your TPN.'),
  Nepal_Legal_Identifier_Description: _TL_('Please provide your PAN.'),
  Pakistan_Legal_Identifier_Description: _TL_('Please provide your NTN.'),
  Sri_Lanka_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Maldives_Legal_Identifier_Description: _TL_('Please provide your TIN.'),
  Account_BusinessLocation_Label: _TL_('Business location'),
  BusinessAddressControl_Address: _TL_('Business address'),
  AddressControl_AddressLine1: _TL_('Address line 1'),
  AddressControl_AddressLine2: _TL_('Address line 2'),
  AddressControl_City: _TL_('City'),
  AddressControl_StateOrProvince: _TL_('State or province'),
  AddressControl_State: _TL_('State'),
  AddressControl_Province: _TL_('Province'),
  AddressControl_ZipCode: _TL_('ZIP code'),
  AddressControl_PostalCode: _TL_('Postal code'),
  AddressControl_ZipOrPostalCode: _TL_('ZIP or Postal code'),
  Billing_InvoiceSettings_EnterNewAddress: _TL_('Enter a new address'),
  AddressControl_LegalBusinessName: _TL_('Legal business name'),
  Customer_CustomerNameRequiredValidationMessage: _TL_('Please enter a business name'),
  Customer_CustomerNameMaxLengthValidationMessage: _TL_('Business name must be 90 characters or less.'),
  Customer_CustomerNameMinLengthValidationMessage: _TL_('Business name must be 2 characters or more.'),
  Billing_Settings_UsersListPhoneNumber: _TL_('Phone number'),
  Common_PhoneNumberRequired: _TL_('Please enter a phone number'),
  Common_BusinessPhoneMaxLengthValidationMessage: _TL_('Business phone must be 50 letters or less'),
  Common_BusinessPhoneMinLengthValidationMessage: _TL_('Business phone must be 1 letter or more'),
  Common_PhoneNumberInvalid: _TL_(
    'Please enter a valid phone number. You may use 0-9, ext, spaces, and the . () - + characters.',
    {
      comment: '"ext" is a part of the regular expression and should not be localized',
    }
  ),
  Validation_NotEmpty_Required_Field: _TL_('This field is required'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Enter a valid value'),
  AddressControl_AddressLine3: _TL_('Address line 3'),
  AddressControl_AddressLine4: _TL_('Address line 4'),
  AddressControl_ProvinceOrRegion: _TL_('Province or region'),
  AddressControl_Country: _TL_('Country or region'),
  TimeZone: _TL_('Time zone'),
  PreferredTimeZone: _TL_('Preferred time zone'),
  TaxOptionType: _TL_('Tax type'),
  Account_VATCertificateVerificationLabel: _TL_('A valid VAT exemption certificate has been provided by the customer.'),
  Account_LocalVATRegistrationNumberLabel: _TL_('This customer provided a local VAT registration number that has been approved by EMEA Tax.'),
  Account_TaxCertification: _TL_('Tax certificate (RUT)'),
  Account_TaxCertificate: _TL_('Tax Certificate'),
  Account_TaxCertificate_Or_EquivalentProof: _TL_('Tax Certificate or Equivalent Proof'),
  Account_TaxCertification_Colombia: _TL_('Tax certificate/RUT document'),
  Account_Tax_Exemption_Certificate: _TL_('Tax exemption certificate'),
  Account_ColombiaVATLabel: _TL_(
    'NIT/Tax ID',
    { comment: 'Label for Tax Id for Colombia customers' }
  ),
  Account_ColombiaVatNumberValidationMessage: _TL_('Please enter a tax registration number to validate your tax certificate.'),
  Account_ColombiaCertificateValidationMessage: _TL_('The file you’ve uploaded is too large. Please reduce the file size to less than 20 megabytes and try again.'),
  Account_ColombiaCertificationExecutionDateValidationMessage: _TL_('Please enter a valid execution date. The format is "YYYY/MM/DD".'),
  Account_ColombiaVATFormatValidationMessage: _TL_('This NIT must be in the following format, where # represents a number: ########-# or #########-#.'),
  Account_CertificateSizeValidationMessage: _TL_('The file you’ve uploaded is too large. Please reduce the file size to less than 20 megabytes and try again.'),
  Account_HungaryVATFormatValidationMessage: _TL_('This VAT ID must be in the following format, where HU is followed by 8 numbers and # represents a number: HU########.'),
  Account_NigeriaVATFormatValidationMessage: _TL_('This VAT ID must be in the following format, where # represents a number: ########-####.'),
  Account_PortugalVATFormatValidationMessage: _TL_('This VAT ID must be in the following format, where PT is followed by 9 numbers and # represents a number: PT#########.'),
  Account_ThailandVATFormatValidationMessage: _TL_('This VAT number must be in the following format: 13 numbers.'),
  Account_AustraliaGSTNumberFormatValidationMessage: _TL_('This ABN is not valid. Please verify and re-enter.'),
  Account_CanadaGSTRegistrationNumberFormatValidationMessage: _TL_('The VAT ID must be in one of the following formats, where # represents a number: #########, #########RT####, or ######### RT###.'),
  Account_CanadaBCPSTRegistrationNumberFormatValidationMessage: _TL_('The VAT ID must be in one of the following formats, where # represents a number: PST-####-####.'),
  Account_CanadaQCQSTRegistrationNumberFormatValidationMessage: _TL_('The VAT ID must be in one of the following formats, where # represents a number: ##########TQ####.'),
  Account_CanadaMBPSTRegistrationNumberFormatValidationMessage: _TL_('The VAT ID must be in one of the following formats, where # represents a number: ######-# or #########MT####.'),
  Account_CanadaSKPSTRegistrationNumberFormatValidationMessage: _TL_('The VAT ID must be in one of the following formats, where # represents a number: #######.'),
  Account_ArmeniaVATFormatValidationMessage: _TL_('This AAH must be in one of the following formats, where # represents a number: ########/0 or ########/1.'),
  Account_BarbadosVATFormatValidationMessage: _TL_('This TIN must be in the following 13-digit format, where # represents a number: #############.'),
  Account_KazakhstanVATFormatValidationMessage: _TL_('This NDS/KKS must be in the following 12-digit format, where # represents a number: ############.'),
  Account_LaosVATFormatValidationMessage: _TL_('This TIN must be in the following 12-digit format, where # represents a number: ############.'),
  Account_MexicoVATFormatValidationMessage: _TL_('Enter a valid VAT registration number without spaces.'),
  Account_NepalVATFormatValidationMessage: _TL_('This VAT ID must be in the following 9-digit format, where # represents a number: #########.'),
  Account_SouthAfricaVATFormatValidationMessage: _TL_('This VAT ID must be in the following 10-digit format, where # represents a number: ##########.'),
  Account_ArgentinaVATFormatValidationMessage: _TL_('The CUIT must be in the following format, where # represents a number: 30-########-#.'),
  Account_AzerbaijanVATFormatValidationMessage: _TL_('The VÖEN must be in the following format, where # represents a number: AZ##########.'),
  Account_BeninVATFormatValidationMessage: _TL_('The IFU must be in the following 13-digit format, where # represents a number: #############.'),
  Account_ChinaVATFormatValidationMessage: _TL_('The Tax ID must be in one of the following formats, where # represents a number or letter: ############### or ##################.'),
  Account_IvoryCoastVATFormatValidationMessage: _TL_('The n° TVA must be in the following format, where # represents a number, and * represents a letter: #######*.'),
  Account_JapanVATFormatValidationMessage: _TL_('The JCT must be in the following 13-digit format, where # represents a number: #############.'),
  Account_MalaysiaVATFormatValidationMessage: _TL_('The SST must be in the following format, where # represents a number, * represents a letter: *##-####-########.'),
  Account_MyanmarVATFormatValidationMessage: _TL_('The TBC must be in the following 9-digit format, where # represents a number: #########.'),
  Account_SurinameVATFormatValidationMessage: _TL_('The FIN must be in the following 10-digit format, where # represents a number: ##########.'),
  Account_TajikistanVATFormatValidationMessage: _TL_('The TIN must be in the following 9-digit format, where # represents a number: #########.'),
  Account_UkraineVATFormatValidationMessage: _TL_('The VAT registration number must be in the following format, where # represents a number or letter: ############.'),
  Account_VenezuelaVATFormatValidationMessage: _TL_('The RIF must be in the following format, where # represents a number: J/G/V/E-#########, or J/G/V/E-########-#.'),
  Account_ZambiaVATFormatValidationMessage: _TL_('The TPIN must be in the following format, where # represents a number: 100#######.'),
  Account_EgyptVATFormatValidationMessage: _TL_('This VAT ID is not valid. Please verify and re-enter.'),
  Account_EgyptTRNFormatValidationMessage: _TL_('This TRN is not valid. Please verify and re-enter.'),
  Account_SouthKoreaVATFormatValidationMessage: _TL_('The BRN must be in the following format, where # represents a number: KR###-##-#####.'),
  Account_PeruVATFormatValidationMessage: _TL_('The RUC must be in the following format, where # represents a number: ###########.'),
  Account_UruguayVATFormatValidationMessage: _TL_('The RUT must be in the following format, where # represents a number: ############.'),
  Account_PanamaVATFormatValidationMessage: _TL_('This RUC is not valid. Please verify and re-enter.'),
  Account_PakistanVATFormatValidationMessage: _TL_('The STRN must be in the following format, where # represents a number: PK#############.'),
  Account_SenegalVATFormatValidationMessage: _TL_('The VAT ID must be in the following format, where # represents a number, and * represents a number or letter: #########***.'),
  Account_TaiwanVATFormatValidationMessage: _TL_('The VAT ID must be in the following format, where # represents a number: ########.'),
  Account_UINValidationMessage: _TL_('This UIN is not valid. Please verify and re-enter.'),
  Common_NA_Text: _TL_('-'),
  FilePicker_ExploreFile: _TL_('Browse'),
  FilePicker_RemoveFile: _TL_('Remove'),
  FilePicker_AddNewFile: _TL_('Add another file'),
  FilePicker_ErrorMessage_Required: _TL_('This field is required'),
  FilePicker_ErrorMessage_Required_VAT: _TL_('Please upload your tax certificate that is associated with your VAT ID.'),
  FilePicker_ErrorMessage_Required_VAT_Colombia: _TL_('Please upload your tax certificate/RUT document associated with your VAT ID.'),
  FilePicker_ErrorMessage_ExtensionNotAllowed: _TL_('Please upload PDF files.'),
  FileUpload_Failed: _TL_('Upload failed. Please retry.'),
  FileUpload_Succeed: _TL_('Successfully uploaded'),
  '{{number}} of {{total}}': _TL_('{{number}} of {{total}}'),
  Account_TaxCertificationStatus_Info_174: _TL_('Your tax certificate has been approved.'),
  Account_TaxCertificationStatus_Info_175: _TL_('Your tax certificate has been rejected.'),
  Account_TaxCertificationStatus_Info_176: _TL_('Your tax certificate is pending for review.'),
  Account_TaxCertificationValidationResult: _TL_('Tax certificate validation result'),
  Account_TaxCertificationStatus_Approve: _TL_('Approve'),
  Account_TaxCertificationStatus_Reject: _TL_('Reject'),
  Account_TaxCertificationExecutionDate: _TL_('Execution date'),
  ValueNoneLabel: _TL_('(Not set)'),
  AddressCountry_HelpPopup_AriaLabel: _TL_('Countries dropdown'),
  BusinessLocation_Tooltip_AriaLabel: _TL_('Business location tooltip'),
  Preferred_Timezone_Tooltip_AriaLabel: _TL_('Preferred time zone tooltip'),
  AddressControl_LegalBusinessName_Tooltip_AriaLabel: _TL_('Legal business name tooltip'),
  Account_TaxCertification_ViewCert: _TL_('view the certificate'),
  Account_Tax_Certificate_Absent: _TL_('Failure to provide your tax exemption certificate may result in tax being applied to your invoice.'),
  Account_Tax_Certificate_Absent_Colombia: _TL_('Failure to provide your NIT/TAX ID and Tax Certificate may result in tax being applied to your invoice.'),
  Account_TaxCertificationDeclineReason: _TL_('Rejection reason'),
  Account_TaxCertificate_DeclineReasonType_1: _TL_('Document submitted is not the Formulario del Registro Unico Tributario Hoja Principal.'),
  Account_TaxCertificate_DeclineReasonType_2: _TL_('None of the fields in section 53 “Cόdigo” contain an 11 or a 48.'),
  Account_TaxCertificate_DeclineReasonType_3: _TL_('The NIT is missing or incomplete.'),
  Account_TaxCertificate_DeclineReasonType_4: _TL_('The NIT number on the certificate does not match the number entered into the Microsoft advertising portal.'),
  Account_VatRequired: _TL_('For accounts with business locations in {{countryName}} we require a valid VAT ID.'),
  AccountGrid_TaxInformation_VatStatus_174: _TL_('Valid'),
  AccountGrid_TaxInformation_VatStatus_175: _TL_('Invalid'),
  AccountGrid_TaxInformation_VatStatus_176: _TL_('Pending'),
  AccountGrid_TaxInformation_VatStatus_177: _TL_('Past due'),
  Account_ChileIVAorVATConfirmLabel: _TL_('Please confirm whether you’re an IVA/VAT tax payer'),
  Account_ChileIVAorVATConfirmPositive: _TL_('Yes'),
  Account_ChileIVAorVATConfirmNegative: _TL_('No'),
  Account_ChileIVAOrVATTaxPayerPositiveLabel: _TL_('The customer has confirmed that they are an IVA/VAT taxpayer.'),
  Account_ChileIVAOrVATTaxPayerNegativeLabel: _TL_('The customer has confirmed that they are not an IVA/VAT taxpayer.'),
  Account_ChileWHTConfirmLabel: _TL_('Please confirm whether the Withholding Tax(WHT) applied to you'),
  Account_ChileWHTConfirmPositive: _TL_('Yes'),
  Account_ChileWHTConfirmNegative: _TL_('No'),
  Account_ChileWithholdingTaxExemptedPositiveLabel: _TL_('The customer has confirmed that the WHT exemption applies to them.'),
  Account_ChileWithholdingTaxExemptedNegativeLabel: _TL_('The customer has confirmed that the WHT exemption does not apply to them.'),
  Account_ChileVATLabel: _TL_('RUT Number'),
  Account_ChileVatNumberValidationMessage: _TL_('This RUT must be in one of the following formats, where # represents a number: ########-# or ########-K.'),
  Account_RUTNumberRequired: _TL_('Failed to provide your RUT number may result in tax being applied to your invoice.'),
  Label_RequiredForIVAorVATTaxPayerCustomers: _TL_('(required for IVA/VAT tax-payers)'),
  GSTINNumberTooltipAriaLabel: _TL_('GST IN number tooltip'),
  GSTINNumberInputAriaLabel: _TL_('GST IN number'),
  PANNumberTooltipAriaLabel: _TL_('PAN number tooltip'),
  PANNumberInputAriaLabel: _TL_('PAN number'),
};

export type LegacyStrings = typeof legacyStrings;
